/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeactivateOrganisation200,
  DeleteLogo200,
  GetOrganisation200,
  OrganisationSummary,
  PagedResponseOrganisationSummary,
  Reactivate200,
  RevokeOrganisationTokens200,
  SearchOrganisationsParams,
  StreamingResponseBody,
  UpdateOrganisationRequest,
  UpdateProfile200,
  UploadLogo200,
  UploadLogoBody
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary Immediately revoke all access/refresh tokens for every user in an organisation, without suspending it
 */
export const revokeOrganisationTokens = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RevokeOrganisationTokens200>(
      {url: `/api/v1/organisations/${id}/revoke-tokens`, method: 'POST', signal
    },
      );
    }
  


export const getRevokeOrganisationTokensMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOrganisationTokens>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeOrganisationTokens>>, TError,{id: string}, TContext> => {

const mutationKey = ['revokeOrganisationTokens'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeOrganisationTokens>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  revokeOrganisationTokens(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeOrganisationTokensMutationResult = NonNullable<Awaited<ReturnType<typeof revokeOrganisationTokens>>>
    
    export type RevokeOrganisationTokensMutationError = unknown

    /**
 * @summary Immediately revoke all access/refresh tokens for every user in an organisation, without suspending it
 */
export const useRevokeOrganisationTokens = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOrganisationTokens>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeOrganisationTokens>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRevokeOrganisationTokensMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Stream an organisation's logo image
 */
export const getLogo = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<StreamingResponseBody>(
      {url: `/api/v1/organisations/${id}/logo`, method: 'GET', signal
    },
      );
    }
  



export const getGetLogoQueryKey = (id?: string,) => {
    return [
    `/api/v1/organisations/${id}/logo`
    ] as const;
    }

    
export const getGetLogoQueryOptions = <TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLogoQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLogo>>> = ({ signal }) => getLogo(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getLogo>>>
export type GetLogoQueryError = unknown


export function useGetLogo<TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogo>>,
          TError,
          Awaited<ReturnType<typeof getLogo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogo<TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLogo>>,
          TError,
          Awaited<ReturnType<typeof getLogo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLogo<TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream an organisation's logo image
 */

export function useGetLogo<TData = Awaited<ReturnType<typeof getLogo>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLogo>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLogoQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Upload/replace an organisation's logo
 */
export const uploadLogo = (
    id: string,
    uploadLogoBody: UploadLogoBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, uploadLogoBody.file)

      return apiClient<UploadLogo200>(
      {url: `/api/v1/organisations/${id}/logo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadLogoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLogo>>, TError,{id: string;data: UploadLogoBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadLogo>>, TError,{id: string;data: UploadLogoBody}, TContext> => {

const mutationKey = ['uploadLogo'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadLogo>>, {id: string;data: UploadLogoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  uploadLogo(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadLogoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadLogo>>>
    export type UploadLogoMutationBody = UploadLogoBody
    export type UploadLogoMutationError = unknown

    /**
 * @summary Upload/replace an organisation's logo
 */
export const useUploadLogo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLogo>>, TError,{id: string;data: UploadLogoBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadLogo>>,
        TError,
        {id: string;data: UploadLogoBody},
        TContext
      > => {

      const mutationOptions = getUploadLogoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Remove an organisation's logo
 */
export const deleteLogo = (
    id: string,
 ) => {
      
      
      return apiClient<DeleteLogo200>(
      {url: `/api/v1/organisations/${id}/logo`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteLogoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLogo>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteLogo>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLogo'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLogo>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLogo(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLogoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLogo>>>
    
    export type DeleteLogoMutationError = unknown

    /**
 * @summary Remove an organisation's logo
 */
export const useDeleteLogo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLogo>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLogo>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteLogoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get an organisation's profile
 */
export const getOrganisation = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetOrganisation200>(
      {url: `/api/v1/organisations/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetOrganisationQueryKey = (id?: string,) => {
    return [
    `/api/v1/organisations/${id}`
    ] as const;
    }

    
export const getGetOrganisationQueryOptions = <TData = Awaited<ReturnType<typeof getOrganisation>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisation>>> = ({ signal }) => getOrganisation(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganisation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisation>>>
export type GetOrganisationQueryError = unknown


export function useGetOrganisation<TData = Awaited<ReturnType<typeof getOrganisation>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganisation>>,
          TError,
          Awaited<ReturnType<typeof getOrganisation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisation<TData = Awaited<ReturnType<typeof getOrganisation>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganisation>>,
          TError,
          Awaited<ReturnType<typeof getOrganisation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisation<TData = Awaited<ReturnType<typeof getOrganisation>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an organisation's profile
 */

export function useGetOrganisation<TData = Awaited<ReturnType<typeof getOrganisation>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganisationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update an organisation's profile — name, address, currency, phone, email, city, postal code, contact person, website, offer terms text, IBAN, bank name, BIC (not tax_id, country, is_active, or logo — see /{id}/logo)
 */
export const updateProfile = (
    id: string,
    updateOrganisationRequest: UpdateOrganisationRequest,
 ) => {
      
      
      return apiClient<UpdateProfile200>(
      {url: `/api/v1/organisations/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganisationRequest
    },
      );
    }
  


export const getUpdateProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{id: string;data: UpdateOrganisationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{id: string;data: UpdateOrganisationRequest}, TContext> => {

const mutationKey = ['updateProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, {id: string;data: UpdateOrganisationRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProfile(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = UpdateOrganisationRequest
    export type UpdateProfileMutationError = unknown

    /**
 * @summary Update an organisation's profile — name, address, currency, phone, email, city, postal code, contact person, website, offer terms text, IBAN, bank name, BIC (not tax_id, country, is_active, or logo — see /{id}/logo)
 */
export const useUpdateProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{id: string;data: UpdateOrganisationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        {id: string;data: UpdateOrganisationRequest},
        TContext
      > => {

      const mutationOptions = getUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Restore a suspended organisation
 */
export const reactivate = (
    id: string,
 ) => {
      
      
      return apiClient<Reactivate200>(
      {url: `/api/v1/organisations/${id}/reactivate`, method: 'PATCH'
    },
      );
    }
  


export const getReactivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivate>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reactivate>>, TError,{id: string}, TContext> => {

const mutationKey = ['reactivate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  reactivate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReactivateMutationResult = NonNullable<Awaited<ReturnType<typeof reactivate>>>
    
    export type ReactivateMutationError = unknown

    /**
 * @summary Restore a suspended organisation
 */
export const useReactivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivate>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getReactivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Suspend an organisation — blocks login/refresh and revokes all its users' tokens immediately
 */
export const deactivateOrganisation = (
    id: string,
 ) => {
      
      
      return apiClient<DeactivateOrganisation200>(
      {url: `/api/v1/organisations/${id}/deactivate`, method: 'PATCH'
    },
      );
    }
  


export const getDeactivateOrganisationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateOrganisation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateOrganisation>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateOrganisation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateOrganisation(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateOrganisation>>>
    
    export type DeactivateOrganisationMutationError = unknown

    /**
 * @summary Suspend an organisation — blocks login/refresh and revokes all its users' tokens immediately
 */
export const useDeactivateOrganisation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateOrganisation>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateOrganisation>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeactivateOrganisationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List all organisations on the platform, with user count and last activity
 */
export const listOrganisations = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<OrganisationSummary[]>(
      {url: `/api/v1/organisations`, method: 'GET', signal
    },
      );
    }
  



export const getListOrganisationsQueryKey = () => {
    return [
    `/api/v1/organisations`
    ] as const;
    }

    
export const getListOrganisationsQueryOptions = <TData = Awaited<ReturnType<typeof listOrganisations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganisationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganisations>>> = ({ signal }) => listOrganisations(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganisations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganisationsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganisations>>>
export type ListOrganisationsQueryError = unknown


export function useListOrganisations<TData = Awaited<ReturnType<typeof listOrganisations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganisations>>,
          TError,
          Awaited<ReturnType<typeof listOrganisations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganisations<TData = Awaited<ReturnType<typeof listOrganisations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganisations>>,
          TError,
          Awaited<ReturnType<typeof listOrganisations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganisations<TData = Awaited<ReturnType<typeof listOrganisations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all organisations on the platform, with user count and last activity
 */

export function useListOrganisations<TData = Awaited<ReturnType<typeof listOrganisations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganisations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganisationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Paginated, filterable organisation list for the platform admin list page
 */
export const searchOrganisations = (
    params?: SearchOrganisationsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseOrganisationSummary>(
      {url: `/api/v1/organisations/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchOrganisationsQueryKey = (params?: SearchOrganisationsParams,) => {
    return [
    `/api/v1/organisations/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchOrganisationsQueryOptions = <TData = Awaited<ReturnType<typeof searchOrganisations>>, TError = unknown>(params?: SearchOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganisations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchOrganisationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchOrganisations>>> = ({ signal }) => searchOrganisations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchOrganisations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchOrganisationsQueryResult = NonNullable<Awaited<ReturnType<typeof searchOrganisations>>>
export type SearchOrganisationsQueryError = unknown


export function useSearchOrganisations<TData = Awaited<ReturnType<typeof searchOrganisations>>, TError = unknown>(
 params: undefined |  SearchOrganisationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganisations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrganisations>>,
          TError,
          Awaited<ReturnType<typeof searchOrganisations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchOrganisations<TData = Awaited<ReturnType<typeof searchOrganisations>>, TError = unknown>(
 params?: SearchOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganisations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrganisations>>,
          TError,
          Awaited<ReturnType<typeof searchOrganisations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchOrganisations<TData = Awaited<ReturnType<typeof searchOrganisations>>, TError = unknown>(
 params?: SearchOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganisations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable organisation list for the platform admin list page
 */

export function useSearchOrganisations<TData = Awaited<ReturnType<typeof searchOrganisations>>, TError = unknown>(
 params?: SearchOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganisations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchOrganisationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




